import { trigger, state, style, transition, animate } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService, GRSSResponse, ValueIdPair } from 'src/app/_services/app.service';

@Component({
    selector: 'app-supporting-docs',
    templateUrl: './supporting-docs.component.html',
    styleUrls: ['./supporting-docs.component.scss'],
    animations: [
        trigger('slider', [
            state('*', style({
                height: 0
            })),
            state('show', style({
                height: '*'
            })),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ])
    ],
    standalone: false
})
export class SupportingDocsComponent implements OnInit {

  markets: ValueIdPair[] = [];
  isSelectedMarket: boolean = false;
  hasUploadedAcceptedFile: Boolean = false;
  latestSubmissions: LatestSubmission[] = [];

  uploadedFile: any;
  fileUpload: DocumentUpload;

  filename: string = '';

  constructor(@Inject('BASE_URL') private baseUrl: string, private http: HttpClient, public service: AppService, private translate: TranslateService) {
    this.service.SetTranslation('my-general-markets/supporting-docs');
   }

  ngOnInit() {
    this.InitializeVariables();
    this.GetMarkets();
  }

  /** Initializes the variables */
  InitializeVariables() {
    this.fileUpload = {
      selectedMarket: '',
      uploadedFile: null
    };
    this.filename = '';
    this.hasUploadedAcceptedFile = false;
  }

  /** List all the markets */
  GetMarkets() {
    this.http.get<ValueIdPair[]>(this.baseUrl + 'api/spreadsheets/getMarkets').subscribe(result => {
      this.markets = result;
    }, error => {
      console.error(error);
    });
  }


  getLatestSubmissions(marketId: string) {
    this.http.get<LatestSubmission[]>(this.baseUrl + 'api/spreadsheets/getLatestSubmissions/' + marketId).subscribe(result => {
      this.latestSubmissions = result;
    }, error => {
      console.error(error);
    });
  }
  /**On Change event for the market */
  OnChangeMarket(marketId: string) {
    this.InitializeVariables();
    this.isSelectedMarket = true;
    this.fileUpload.selectedMarket = marketId;
    this.getLatestSubmissions(marketId);
  }

  /**Click event for the submit button */
  OnClickSubmit() {
    if (this.hasUploadedAcceptedFile === false) {
      if (this.filename === '') {
        this.service.SaveStatus(false, 'SupportingDocs.Messages.msgHeaderInvFile', 'SupportingDocs.Messages.msgParaEmptyFile');
      } else {
        this.service.SaveStatus(false, 'SupportingDocs.Messages.msgHeaderInvFile', 'SupportingDocs.Messages.msgParaInvFileType');
      }
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(this.uploadedFile);
      reader.onload = (event: any) => {
        this.fileUpload.uploadedFile.base64String = event.target.result;
        this.service.showSpinner();
        this.http.post<GRSSResponse>(this.baseUrl + 'api/spreadsheets/uploadDocument', this.fileUpload).subscribe(result => {
          if (result.statusCode === 4) {
            this.service.SaveStatus(true, 'SupportingDocs.header', result.statusMessage);
          } else if (result.statusCode === 1) {
            this.service.SaveStatus(false, 'SupportingDocs.header', result.statusMessage);
            this.OnChangeMarket(this.fileUpload.selectedMarket);
          } else {
            this.service.SaveStatus(false, this.translate.instant('SupportingDocs.header'), result.statusMessage, true);
          }
        }, error => {
          console.error(error);
        }).add(() => {
          this.service.hideSpinner();
        });
      };
      reader.onerror = (error) =>  {
        console.error('Error: ', error);
        this.service.SaveStatus(false, 'SupportingDocs.header', 'SupportingDocs.Messages.msgErrorUpldFile');
      };
    }
  }

  /** Fires when user changes the upload file */
  spreadsheetInputChange(fileInputEvent: any) {
    const acceptFileTypes: string[] = [ 'xls', 'xlsx' ];
    this.filename = fileInputEvent.target.files[0].name;
    this.hasUploadedAcceptedFile = false;
    if (this.filename) {
      const fileSplit = this.filename.split('.');
      if (acceptFileTypes.includes(fileSplit[fileSplit.length - 1])) {
        this.hasUploadedAcceptedFile = true;
        this.uploadedFile = fileInputEvent.target.files[0];
        this.fileUpload.uploadedFile = {
          base64String: '',
          extension: fileSplit[fileSplit.length - 1],
          name: this.filename.replace('.' + fileSplit[fileSplit.length - 1], '')
        };
      }
      if (this.filename.length > 40) {
        // this.filename = this.filename.substr(0, 30) + '____.' + fileSplit[1];
      }
    }

    if (this.hasUploadedAcceptedFile === false) {
      this.service.SaveStatus(false, 'SupportingDocs.Messages.msgHeaderInvFile', 'SupportingDocs.Messages.msgParaInvFileType');
    }
  }

  OnClickSpreadsheet(submission: LatestSubmission) {
    const byteCharacters = atob(submission.base64Value);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.download = submission.fileName;
    anchor.href = url;
    anchor.click();
    // window.open(url);
    document.removeChild(anchor);
  }

}

/** Inteface for access the document upload details */
interface DocumentUpload {
  selectedMarket: string;
  uploadedFile: UploadedFile;
}

/** Interface for access the uploaded document details */
interface UploadedFile {
  name: string;
  extension: string;
  base64String: string;
}

/** Interface for access the latest submission details */
interface LatestSubmission {
  fileName: string;
  date: string;
  base64Value: string;
}

